export default "__VITE_ASSET__agKNzEjN__"